import React from "react";

const calender = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.625 3V4.875M14.375 3V4.875M2.5 16.125V6.75C2.5 6.25272 2.69754 5.77581 3.04917 5.42417C3.40081 5.07254 3.87772 4.875 4.375 4.875H15.625C16.1223 4.875 16.5992 5.07254 16.9508 5.42417C17.3025 5.77581 17.5 6.25272 17.5 6.75V16.125M2.5 16.125C2.5 16.6223 2.69754 17.0992 3.04917 17.4508C3.40081 17.8025 3.87772 18 4.375 18H15.625C16.1223 18 16.5992 17.8025 16.9508 17.4508C17.3025 17.0992 17.5 16.6223 17.5 16.125M2.5 16.125V9.875C2.5 9.37772 2.69754 8.90081 3.04917 8.54917C3.40081 8.19754 3.87772 8 4.375 8H15.625C16.1223 8 16.5992 8.19754 16.9508 8.54917C17.3025 8.90081 17.5 9.37772 17.5 9.875V16.125"
        stroke="#3B3B3B"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default calender;
